<template>
  <div class="flex flex-col flex-1 min-h-0 relative bg-white rounded-b-lg pb-3">
    <div v-if="getCurrentDiscussion && getCurrentDiscussion.audio_discussion_is_enabled === true" class="flex flex-col flex-1 min-h-0">
      <div v-if="discussion_is_live" class="flex flex-col flex-1 min-h-0">
        <div v-if="!has_joined_discussion" class="flex flex-1 flex-col justify-center -mt-20 items-center min-h-0 space-y-8 overflow-y-auto px-3 py-3">
          <JoinDiscussion :isJoinedAudioDiscussion="joinedAudioDiscussion" />
        </div>
        <div v-else class="flex flex-col flex-1 min-h-0 px-3 py-3">
          <div v-if="discussion_is_live" class="flex w-full relative items-start flex-1 min-h-0 space-x-1.5">
            <div
              :class="[{
                'w-3/12 2xl:w-2/12 h-full flex-col space-y-1.5 overflow-y-auto': isDiscussionSharingScreen === true && selectedLiveView === 'one_columns',
                'w-full h-full': isDiscussionSharingScreen === true && selectedLiveView === 'only_screen',
                'h-full grid gap-1.5 w-full sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 overflow-y-auto': isDiscussionSharingScreen === false && isNotepadOpen === false && !tap_in_screen,
                'h-full grid gap-1.5 w-full sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 overflow-y-auto': isDiscussionSharingScreen === false && isNotepadOpen === true && !tap_in_screen,
                'w-full h-full px-4 py-4': tap_in_screen,
              }]"
            >
              <div v-if="(audio_is_enabled || tap_in_screen) && course_author" v-show="(tap_in_screen && tap_in_screen === course_author.id) || !tap_in_screen" class="relative">
                <div class="absolute -mt-5 text-white rounded-t w-full flex justify-center bg-gray-400" v-if="!tap_in_screen">
                  Author
                </div>
                <LDDiscussionTeacherCircle
                  :id="`circle-list-${course_author.id}`"
                  :joinedAudioDiscussion="joinedAudioDiscussion"
                  :remoteUsers="remoteUsers"
                  :rtc="rtc"
                  :teacher_tap_in="tap_in_screen"
                  :course_author="course_author"
                />
                <div v-if="tap_in_screen">Teacher Tap In</div>
              </div>
              <div 
                v-if="(audio_is_enabled || tap_in_screen) && isTeacherOnline(getCurrentDiscussion.author_id)" 
                v-show="(tap_in_screen && tap_in_screen === getCurrentDiscussion.author_id) || (!tap_in_screen && selectedLiveView !== 'only_screen')" 
                class="relative w-full overflow-y-hidden h-full"
              >
                <LDDiscussionTeacherCircle
                  :id="`circle-list-${getCurrentDiscussion.author_id}`"
                  :joinedAudioDiscussion="joinedAudioDiscussion"
                  :remoteUsers="remoteUsers"
                  :rtc="rtc"
                  :teacher_tap_in="tap_in_screen"
                />
              </div>
              <div
                v-if="(audio_is_enabled || tap_in_screen) && isCoTeacherOnline(coteacher.id)"
                v-show="(tap_in_screen && tap_in_screen === coteacher.id) || !tap_in_screen || selectedLiveView !== 'only_screen'"
                v-for="(coteacher, index) in co_teachers"
                :key="coteacher.id + index"
                class="relative"
              >
                <div class="text-white text-xs py-0.5 font-poppins rounded-t w-full flex justify-center bg-gray-400" v-if="!tap_in_screen">
                  Co-Teacher
                </div>
                <LDDiscussionCoTeacherCircle
                  :id="`circle-list-${coteacher.id}`"
                  :coteacher="coteacher"
                  :joinedAudioDiscussion="joinedAudioDiscussion"
                  :remoteUsers="remoteUsers"
                  :rtc="rtc"
                  :co_teacher_tap_in="tap_in_screen"
                />
                <div v-if="tap_in_screen" class="font-poppins bg-gray-100 rounded-full px-3.5 border border-solid border-gray-200 py-2 mt-5">
                  Co-Teacher Tap In
                </div>
              </div>
              <div
                v-if="speakerInTurnCircle === false"
                v-show="selectedLiveView !== 'only_screen'"
                class="relative"
                :class="tap_in_screen ? 'hidden' : ''"
              >
                <div class="relative bg-gray-100 rounded-b-md h-56">
                  <div class="bg-gray-400 w-full text-white rounded-t text-xs font-poppins py-0.5 flex justify-center">
                    Speaker
                  </div>
                  <div class="absolute" style="top: calc(50% - 40px); left: calc(50% - 32px)">
                    <div class="rounded-full bg-gray-200" style="width: 70px; height: 70px"></div>
                  </div>
                  <div class="absolute left-3 bottom-2.5 w-20 h-7 rounded-full bg-gray-200"></div>
                </div>
              </div>
              <div v-for="(turn, index) in turns_in_circle" :key="turn.id" v-show="selectedLiveView !== 'only_screen'" :class="tap_in_screen ? 'hidden' : ''">
                <LDDiscussionCircle
                  :id="`circle-list-${turn.participation.user.id}`"
                  :currentTurn="turn"
                  :currentSpeaker="current_speaker"
                  :queueIndex="index"
                  :participationID="turn.participation.id"
                  :joinedAudioDiscussion="joinedAudioDiscussion"
                  :remoteUsers="remoteUsers"
                  :loading_queue="loading_queue"
                  @openSendNudge="$emit('openSendNudge', true, turn.participation)"
                />
              </div>
            </div>
            <div v-if="isDiscussionSharingScreen === true"
              :class="[{
                'w-8/12 relative flex flex-col min-h-0': selectedLiveView === 'columns',
                'w-9/12 2xl:w-10/12 relative flex flex-col min-h-0': selectedLiveView === 'one_columns',
                'absolute inset-0 w-full': selectedLiveView === 'only_screen',
              }]"
            >
              <div :class="['relative w-full overflow-hidden', selectedLiveView === 'only_screen' ? 'h-full': 'aspect-w-16 aspect-h-9']">
                <div :id="'screen-share-container'" class="absolute inset-0 w-full flex flex-col justify-center items-center bg-gray-800 border border-solid border-gray-200">
                  <div class="flex absolute bottom-2 left-2 z-50 items-center space-x-2">
                    <div v-if="getCurrentDiscussion.is_sample === false">
                      <Tooltip v-if="show_bad_network_quality" text="The connection is weak" styleTooltip="-top-1 right-full mr-2.5" padding="px-2.5 py-1">
                        <i class="fas fa-wifi text-red-500 cursor-pointer mb-1.5"></i>
                      </Tooltip>
                    </div>
                    <pl-menu :menuSize="3" direction="right">
                      <button slot="menu_trigger" v-if="isDiscussionSharingScreen" class="bg-gray-50 border border-solid -mt-1.5 border-gray-300 h-8 rounded-full flex items-center text-xs space-x-2 text-gray-700 px-2.5 py-1.5">
                        <i class="fa-solid fa-table-columns"></i>
                        <i class="fa-solid fa-chevron-down"></i>
                      </button>
                      <ul menu-content class="text-sm text-gray-700">
                        <li @click="handleChangeView('one_columns')" class="bg-white border-b border-solid border-gray-200 cursor-pointer hover:bg-gray-100 py-1.5 px-2">
                          <span>Normal</span>
                        </li>
                        <li @click="handleChangeView('only_screen')" class="bg-white hover:bg-gray-100 cursor-pointer py-1.5 px-2">
                          <span>Only Screen</span>
                        </li>
                      </ul>
                    </pl-menu>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section
            v-if="discussion_is_live && audio_is_enabled"
            v-show="has_joined_discussion && selectedLiveView !== 'only_screen'"
            class="flex pt-2 border-t border-gray-200 w-full mt-auto mb-[calc(var(--toolbar-h)+0.75rem)]"
          >
            <button
              v-if="show_arrows"
              @click="slide('left')"
              class="opacity-50 hover:opacity-100"
            >
              <i class="fas fa-angle-left mr-2.5 text-xl" />
            </button>
            <div class="slides-container" id="slides-container">
              <div
                v-if="!hasTeacherPermissionsInCourse"
                class="relative mr-1"
                @mouseover="isToSeeSettings = true"
                @mouseleave="isToSeeSettings = false"
              >
                <div class="bg-gray-50 border border-solid border-gray-200 rounded-lg relative" style="width: 120px; height: 75px">
                  <div class="w-full flex flex-col h-full relative">
                    <div class="flex-grow relative">
                      <div class="flex justify-center flex-grow h-full">
                        <div v-show="!camera" class="flex flex-col justify-center items-center h-full">
                          <img :src="getProfile.avatar_url" alt="Avatar" class="rounded-full w-6 h-6" />
                        </div>
                        <div v-show="camera" class="h-full">
                          <video class="local-camera absolute object-cover inset-0 w-full h-full" :class="present_in_circle ? 'opacity-50' : ''" autoplay></video>
                        </div>
                      </div>
                      <div class="z-10 select-none absolute bg-pinky text-white px-2 rounded-full py-0.5 bottom-2 right-2 text-xs opacity-80">
                        <span>Me</span>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  v-if="camera && isToSeeSettings"
                  @click="openDeviceSettings"
                  class="absolute top-6 left-12 z-10"
                >
                  <i class="fa-solid fa-gear text-white text-base" />
                </button>
              </div>
              <!-- Carousel Horizontal Users -->
              <div v-if="turns_video_audio_on.length" class="flex space-x-1" id="slide-cards">
                <div
                  v-for="turn in turns_video_audio_on"
                  :key="turn.id"
                  :id="`circle-list-${turn.participation.user.id}`"
                  :class="hasTeacherPermissionsInCourse ? 'cursor-pointer' : ''"
                  class="relative bg-gray-100"
                  style="width: 120px; height: 75px"
                  @click="openStudentAssessment(turn)"
                >
                  <div class="w-full h-full flex items-center justify-center">
                    <img :src="turn.participation.user.avatar_url" alt="Avatar" class="rounded-full w-10 h-10" />
                  </div>
                  <div class="absolute bottom-2 right-2 px-2 py-0.5 bg-black rounded-full text-white text-xs opacity-60 z-10">
                    {{ turn.participation.user.name.split(' ')[0] }}
                  </div>
                </div>
              </div>
              <!-- Carousel Preview -->
              <div v-else class="flex items-center space-x-1 w-full">
                <div v-for="i in 3" :key="i" class="relative bg-gray-100 rounded" style="height: 75px; width: 120px">
                  <div class="absolute bottom-2.5 left-2.5 w-10 rounded-full h-4 bg-gray-200"></div>
                </div>
              </div>
            </div>
            <button
              v-if="show_arrows"
              @click="slide('right')"
              class="opacity-50 hover:opacity-100"
            >
              <i class="fas fa-angle-right ml-2.5 text-xl" />
            </button>
          </section>
        </div>
        <transition name="bar-fade-slide">
          <div v-show="!(discussion_is_live && isIdle)" class="w-full sticky bottom-3 px-3 z-40">
            <LDDiscussionTeacherBar
              v-if="hasTeacherPermissionsInCourse"
              @show_polls="show_polls = true"
              @show_questions="show_discussion_questions_modal = true"
              @handleChangeVideoStatus="handleToggleVideo()"
              @handleChangeMicroStatus="handleToggleMicro()"
              @toggleFullscreen="$emit('toggleFullscreen')"
              :statusCamera="camera"
              :statusMicro="muted"
              :joinedAudioDiscussion="joinedAudioDiscussion"
            />
            <LDDiscussionStudentBar
              v-else
              @show_polls="show_polls = true"
              @handleChangeVideoStatus="handleToggleVideo()"
              @handleChangeMicroStatus="handleToggleMicro()"
              @toggleFullscreen="$emit('toggleFullscreen')"
              :statusCamera="camera"
              :statusMicro="muted"
              :joinedAudioDiscussion="joinedAudioDiscussion"
            />
          </div>
        </transition>
      </div>
      <div v-else class="flex flex-col flex-1 min-h-0">
        <div v-if="!discussion_is_live" class="flex flex-col flex-1 min-h-0 h-full overflow-y-auto justify-center items-center">
          <div v-if="discussion_is_ended && getCurrentDiscussion.participations.length > 0" class="h-full flex flex-col items-center justify-center p-6 font-manrope">
            <VerbalDiscussionEnded/>
          </div>
          <div v-else class="h-full w-full">
            <VerbalDiscussionOffline/>
          </div>
        </div>
        <transition name="bar-fade-slide">
          <div v-if="getCurrentDiscussion.participations.length > 0" class="w-full sticky bottom-3 px-3 z-40">
            <LDDiscussionTeacherBar
              v-if="hasTeacherPermissionsInCourse"
              @show_polls="show_polls = true"
              @show_questions="show_discussion_questions_modal = true"
              @handleChangeVideoStatus="handleToggleVideo()"
              @handleChangeMicroStatus="handleToggleMicro()"
              @toggleFullscreen="$emit('toggleFullscreen')"
              :statusCamera="camera"
              :statusMicro="muted"
              :joinedAudioDiscussion="joinedAudioDiscussion"
            />
            <LDDiscussionStudentBar
              v-else
              @show_polls="show_polls = true"
              @handleChangeVideoStatus="handleToggleVideo()"
              @handleChangeMicroStatus="handleToggleMicro()"
              @toggleFullscreen="$emit('toggleFullscreen')"
              :statusCamera="camera"
              :statusMicro="muted"
              :joinedAudioDiscussion="joinedAudioDiscussion"
            />
          </div>
        </transition>
      </div>
    </div>
    <div v-else class="flex flex-col flex-1 min-h-0">
      <div v-if="discussion_is_live" class="flex flex-col flex-1 min-h-0">
        <div class="flex-1 min-h-0 overflow-y-auto px-3 py-3" v-show="!tap_in_screen">
          <div :class="[{
              'h-full grid gap-1.5 w-full sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 overflow-y-auto': isDiscussionSharingScreen === false && isNotepadOpen === false && !tap_in_screen, 
              'h-full grid gap-1.5 w-full sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 overflow-y-auto': isDiscussionSharingScreen === false && isNotepadOpen === true && !tap_in_screen,
            }]">
            <div v-if="speakerInTurnCircle === false" class="relative">
              <div class="relative bg-gray-100 rounded-b-md h-56">
                <div class="bg-gray-400 w-full text-white rounded-t text-xs font-poppins py-0.5 flex justify-center">
                  Speaker
                </div>
                <div class="absolute" style="top: calc(50% - 40px); left: calc(50% - 32px)">
                  <div class="rounded-full bg-gray-200" style="width: 70px; height: 70px"></div>
                </div>
                <div class="absolute left-3 bottom-2.5 w-20 h-7 rounded-full bg-gray-200"></div>
              </div>
            </div>
            <div v-for="(turn, index) in turns_in_circle" :key="turn.id" :class="tap_in_screen ? 'hidden' : ''">
              <LDDiscussionCircle
                :id="`circle-list-${turn.participation.user.id}`"
                :currentTurn="turn"
                :currentSpeaker="current_speaker"
                :queueIndex="index"
                :participationID="turn.participation.id"
                :joinedAudioDiscussion="joinedAudioDiscussion"
                :remoteUsers="remoteUsers"
                :loading_queue="loading_queue"
                @openSendNudge="$emit('openSendNudge', true, turn.participation)"
              />
            </div>
          </div>
        </div>
        <div class="flex-1 min-h-0 overflow-y-auto px-3 py-3 flex flex-col justify-center items-center" v-show="tap_in_screen">
          <LDDiscussionTeacherCircle
            :id="`circle-list-${getCurrentDiscussion.author_id}`"
            :joinedAudioDiscussion="joinedAudioDiscussion"
            :remoteUsers="remoteUsers"
            :rtc="rtc"
            :teacher_tap_in="tap_in_screen"
          />
        </div>
        <transition name="bar-fade-slide">
          <div v-show="!isIdle" class="w-full sticky bottom-3 px-3 z-40">
            <LDDiscussionTeacherBar
              v-if="hasTeacherPermissionsInCourse"
              @show_polls="show_polls = true"
              @show_questions="show_discussion_questions_modal = true"
              @handleChangeVideoStatus="handleToggleVideo()"
              @handleChangeMicroStatus="handleToggleMicro()"
              @toggleFullscreen="$emit('toggleFullscreen')"
              :statusCamera="camera"
              :statusMicro="muted"
              :joinedAudioDiscussion="joinedAudioDiscussion"
            />
            <LDDiscussionStudentBar
              v-else
              @show_polls="show_polls = true"
              @handleChangeVideoStatus="handleToggleVideo()"
              @handleChangeMicroStatus="handleToggleMicro()"
              @toggleFullscreen="$emit('toggleFullscreen')"
              :statusCamera="camera"
              :statusMicro="muted"
              :joinedAudioDiscussion="joinedAudioDiscussion"
            />
          </div>
        </transition>
      </div>
      <div v-else class="flex flex-col flex-1 min-h-0">
        <div v-if="!discussion_is_live" class="flex flex-col flex-1 min-h-0 h-full overflow-y-auto justify-center items-center">
          <div v-if="discussion_is_ended && getCurrentDiscussion.participations.length > 0" class="h-full flex flex-col items-center justify-center p-6 font-manrope">
            <VerbalDiscussionEnded/>
          </div>
          <div v-else class="h-full w-full">
            <VerbalDiscussionOffline/>
          </div>
        </div>
        <transition name="bar-fade-slide">
          <div v-if="getCurrentDiscussion.participations.length > 0" class="w-full sticky bottom-3 px-3 z-40">
            <LDDiscussionTeacherBar
              v-if="hasTeacherPermissionsInCourse"
              @show_polls="show_polls = true"
              @show_questions="show_discussion_questions_modal = true"
              @handleChangeVideoStatus="handleToggleVideo()"
              @handleChangeMicroStatus="handleToggleMicro()"
              @toggleFullscreen="$emit('toggleFullscreen')"
              :statusCamera="camera"
              :statusMicro="muted"
              :joinedAudioDiscussion="joinedAudioDiscussion"
            />
            <LDDiscussionStudentBar
              v-else
              @show_polls="show_polls = true"
              @handleChangeVideoStatus="handleToggleVideo()"
              @handleChangeMicroStatus="handleToggleMicro()"
              @toggleFullscreen="$emit('toggleFullscreen')"
              :statusCamera="camera"
              :statusMicro="muted"
              :joinedAudioDiscussion="joinedAudioDiscussion"
            />
          </div>
        </transition>
      </div>
    </div>
    <pl-dialog
      v-if="second_screen_modal"
      :title="'Second Screen'"
      :size="'relative'"
      :disableOutsideClick="true"
      @close="second_screen_modal = false"
    >
      <div class="flex-grow p-7">
        <div class="h-full flex flex-col">
          <p>
            Share this onto a second screen for your class to view in addition
            to what they see on their own devices.
          </p>
          <p>
            This screen will not show you taking notes, nudging or assessing
            students as that will occur in the existing Parlay tab on your
            device.
          </p>
        </div>
      </div>
      <div class="flex justify-center px-7 pb-7">
        <button
          class="px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold"
          @click="second_screen_modal = false"
        >
          OK, got it!
        </button>
      </div>
    </pl-dialog>
    <NewFeedbackModal
      v-if="show_saved_feedback_modal"
      @close="closeNewFeedbackModal"
      typeRoundtable="live"
      :feedbackID="feedback_id"
      :feedbackContent="feedback_content"
      :editingFeedback="set_edit_saved_feedback"
    />
    <ImportFeedbackModal
      v-if="show_import_feedback_modal"
      @close="closeImportFeedbackTemplatesModal"
      typeRoundtable="live"
    />
    <dialog-delete-confirm
      v-if="show_confirm_delete_feedback"
      @close="cancelDeleteSavedFeedback"
      @actionConfirmed="confirmDeleteSavedFeedback"
      :header="'Delete this saved feedback template'"
      :subHeader="'It will be permanently removed from this course.'"
    />
  </div>
</template>
<script>
  import moment from 'moment';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import LDDiscussionTeacherBar from 'features/liveDiscussion/components/LDDiscussionTeacherBar.vue';
  import LDDiscussionStudentBar from 'features/liveDiscussion/components/LDDiscussionStudentBar.vue';
  import LDDiscussionCircle from 'features/liveDiscussion/components/LDDiscussionCircle.vue';
  import LDDiscussionTeacherCircle from 'features/liveDiscussion/components/LDDiscussionTeacherCircle.vue';
  import LDDiscussionCoTeacherCircle from 'features/liveDiscussion/components/LDDiscussionCoTeacherCircle.vue';
  import DiscussionCircleMessages from 'features/liveDiscussion/components/discussionCircleMessages.vue';
  import GuidingQuestionsModal from 'features/liveDiscussion/components/modals/guidingQuestionsModal';
  import toggleOwnAudio from 'services/liveDiscussion/toggleOwnAudio.js';
  import toggleOwnVideo from 'services/liveDiscussion/toggleOwnVideo.js';
  import turnOffStudentParticipation from 'services/liveDiscussion/turnOffStudentParticipation.js';
  import Tooltip from 'components/Tooltip.vue';
  import { internetConnection } from '../internetConnection';
  import ImportFeedbackModal from 'components/modals/ImportFeedbackModal.vue';
  import NewFeedbackModal from 'components/modals/NewFeedbackModal.vue';
  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';
  import Checklist from 'components/checklist.vue';
  import VerbalDiscussionOffline from './DiscussionTab/VerbalDiscussionOffline.vue';
  import VerbalDiscussionEnded from './DiscussionTab/VerbalDiscussionEnded.vue';

  export default {
    data() {
      return {
        muted: true,
        camera: false,
        discussion_time: '',
        uplinkNetworkQuality: 0,
        downlinkNetworkQuality: 0,
        show_stopped_modal: false,
        show_polls: false,
        show_discussion_questions_modal: false,
        show_bad_network_quality: false,
        canvasHeight: 90,
        canvasWidth: 120,
        isChangingToggleVideo: false,
        isToSeeSettings: false,
        loading_queue: false,
        local_camera_disabled: false,
        second_screen_modal: false,
        show_saved_feedback_modal: false,
        show_import_feedback_modal: false,
        set_edit_saved_feedback: false,
        show_confirm_delete_feedback: false,
        feedback_content: '',
        feedback_id: '',
        feedback_to_delete: {},
        show_arrows: false,
        isNotepadOpen: true,
        showTeacherBar: true,
        mouseMoving: true,
        selectedLiveView: 'one_columns',
        isIdle: false,
        idleMs: 4000,
        _idleTimer: null,
      };
    },
    props: {
      joinedAudioDiscussion: {
        type: Boolean,
        default: false,
      },
      rtc: {
        type: Object,
        default: {
          client: null,
          localAudioTrack: null,
          localVideoTrack: null,
        },
      },
      screenRTC: {
        type: Object,
        default: {
          client: null,
          screenTrack: null,
        },
      },
      isFullscreen: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      LDDiscussionTeacherBar,
      LDDiscussionStudentBar,
      LDDiscussionCircle,
      LDDiscussionTeacherCircle,
      LDDiscussionCoTeacherCircle,
      GuidingQuestionsModal,
      DiscussionCircleMessages,
      Tooltip,
      NewFeedbackModal,
      ImportFeedbackModal,
      dialogDeleteConfirm,
      Checklist,
      JoinDiscussion: () => import('./DiscussionTab/VideoCall/JoinDiscussion.vue'),
      VerbalDiscussionOffline,
      VerbalDiscussionEnded
    },
    watch: {
      joinedAudioDiscussion() {
        if (this.joinedAudioDiscussion) {
          this.$nextTick(async () => {
            if (this.hasTeacherPermissionsInCourse) {
              await this.createTeacherLocalVideoTrack();
            } else {
              await this.createStudentLocalVideoTrack();
              const videoTrackOn = this.remoteUsers.filter(
                (r) => r._videoTrack
              );
              if (videoTrackOn.length < 12) this.toggleLocalCamera();
            }
            this.showArrows();
          });
        }
      },
      'getCurrentDiscussion.is_live'() {
        this.camera = false;
        this.muted = true;
      },
      turns_video_audio_on() {
        this.showArrows();
      },
    },
    computed: {
      ...mapGetters([
        'hasTeacherPermissionsInCourse',
        'getCurrentDiscussion',
        'getProfile',
        'getCourseDetail',
        'getQueue',
        'getStudentSummaryLD',
      ]),
      onlineStudents() {
        const online_students = [];
        this.getCurrentDiscussion.participations.forEach((participation) => {
          if (this.isStudentOnline(participation.user.id)) {
            online_students.push(participation);
          }
        });
        return online_students;
      },
      discussion_is_live() {
        return this.getCurrentDiscussion.is_live;
      },
      isDiscussionSharingScreen() {
        return this.getCurrentDiscussion.is_screen_sharing_active;
      },
      discussion_is_ended() {
        return this.getCurrentDiscussion.is_ended;
      },
      audio_is_enabled() {
        return this.getCurrentDiscussion.audio_discussion_is_enabled;
      },
      co_teachers() {
        return this.getCurrentDiscussion.co_teachers;
      },
      course_author() {
        return this.getCourseDetail.users.find(
          (user) =>
            user.subscription.role === 'author' &&
            user.id !== this.getCurrentDiscussion.author_id
        );
      },
      speakerInTurnCircle: function () {
        let isSpeaker = false;
        this.getCurrentDiscussion.turns_in_circle.forEach((turn) => {
          if (turn.queue_position === 0) {
            isSpeaker = true;
          }
        });
        return isSpeaker;
      },
      audio_is_active() {
        return (
          this.getCurrentDiscussion.audio_discussion_is_enabled &&
          this.getCurrentDiscussion.is_live
        );
      },
      has_joined_discussion() {
        if (!this.audio_is_active) return true;
        return this.joinedAudioDiscussion;
      },
      present_in_circle() {
        const circle = this.getCurrentDiscussion.turns_in_circle;
        const presence = circle.find(
          (t) =>
            t.participation.user.id === this.getProfile.id &&
            t.turn_type !== 'video_audio_on'
        );
        return Boolean(presence);
      },
      tap_in_screen() {
        return this.getCurrentDiscussion.teacher_tapped_in_id;
      },
      my_participation() {
        return this.getCurrentDiscussion.participations.find(
          (p) => p.user_id === this.getProfile.id
        );
      },
      iam_moderator() {
        if (this.my_participation && this.my_participation.is_moderator) {
          return true;
        }
        return false;
      },
      current_speaker() {
        return this.getCurrentDiscussion.turns_in_circle.find(
          (t) =>
            t.participation.user.id ===
            this.getCurrentDiscussion.currently_active
        );
      },
      turns_on_queue() {
        return this.getCurrentDiscussion.queue;
      },
      turns_in_circle() {
        if (this.getCurrentDiscussion.audio_discussion_is_enabled) {
          return this.getCurrentDiscussion.turns_in_circle.filter(
            (t) => t.turn_type !== 'video_audio_on'
          );
        }
        return this.getCurrentDiscussion.turns_in_circle;
      },
      turns_video_audio_on() {
        if (this.getCurrentDiscussion.audio_discussion_is_enabled) {
          const turns = this.getCurrentDiscussion.turns_in_circle.filter((t) => t.turn_type === 'video_audio_on');
          if (turns) {
            const index = turns.findIndex((t) => t.participation.user.id === this.getProfile.id);
            if (index !== -1) turns.splice(index, 1);
          }
          return turns;
        }
        return [];
      },
      remoteUsers() {
        if (this.rtc && this.rtc.client) {
          return this.rtc.client.remoteUsers;
        }
        return [];
      },
      second_screen() {
        return this.$route.query.second_screen;
      },
      turns_total() {
        return (
          this.getStudentSummaryLD.times_spoken &&
          this.getStudentSummaryLD.times_spoken.turns_total
        );
      },
      discussionCircleContainer() {
        if (this.audio_is_active && this.has_joined_discussion) {
          return this.isFullscreen
            ? 'discussion-circle-container-video-fullscreen'
            : 'discussion-circle-container-video';
        }
        return this.isFullscreen
          ? 'discussion-circle-container-fullscreen'
          : 'discussion-circle-container';
      },
    },
    methods: {
      _setActive() {
        this.isIdle = false;
        if (this._idleTimer) clearTimeout(this._idleTimer);
        this._idleTimer = setTimeout(() => {
          this.isIdle = true;
        }, this.idleMs);
      },
      _addIdleListeners() {
        const opts = { passive: true };
        window.addEventListener('mousemove', this._setActive, opts);
        window.addEventListener('mousedown', this._setActive, opts);
        window.addEventListener('keydown', this._setActive, opts);
        window.addEventListener('wheel', this._setActive, opts);
        window.addEventListener('touchstart', this._setActive, opts);
      },
      _removeIdleListeners() {
        window.removeEventListener('mousemove', this._setActive);
        window.removeEventListener('mousedown', this._setActive);
        window.removeEventListener('keydown', this._setActive);
        window.removeEventListener('wheel', this._setActive);
        window.removeEventListener('touchstart', this._setActive);
      },
      handleChangeView: function (option) {
        this.selectedLiveView = option;
      },
      handleMouseMove() {
        this.mouseMoving = true;
        clearTimeout(this.mouseMoveTimeout);
        this.mouseMoveTimeout = setTimeout(() => {
          this.mouseMoving = false;
        }, 5000);
      },
      startMouseMoveTimer() {
        setInterval(() => {
          if (!this.mouseMoving) {
            this.showContent = false;
          } else {
            this.showContent = true;
          }
        }, 500);
      },
      handleToggleVideo: async function () {
        await this.toggleLocalCamera();
      },
      handleToggleMicro: async function () {
        this.muted = !this.muted;
        if (this.muted) {
          EventBus.$emit('muteAudio');
        } else {
          EventBus.$emit('unmuteAudio');
        }
        await toggleOwnAudio(this.$route.params.liveDiscussionID);
      },
      isStudentOnline: function (studentId) {
        return this.getCurrentDiscussion.users_present.includes(studentId);
      },
      handleStartVerbal: async function () {
        if (this.getCurrentDiscussion.is_ended) {
          await this.$store.dispatch('restartLiveDiscussion', this.getCurrentDiscussion.id);
          EventBus.$emit('restartLD');
        } else {
          if (!this.getCurrentDiscussion.participations.length) {
            const toast = {
              type: 'Info',
              message: 'You need to invite students before starting the discussion.',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
            return;
          }
          EventBus.$emit('handleOpenStartDiscussionModal');
        }
      },
      handleChangeTab: async function (tab) {
        EventBus.$emit('handleTab', tab);
      },
      async toggleLocalCamera() {
        const videoTrackOn = this.remoteUsers.filter((r) => r._videoTrack);
        this.local_camera_disabled = true;
        setTimeout(() => {
          this.local_camera_disabled = false;
        }, 1000 * 2);
        if (this.camera) {
          this.stopLocalCameraStream();
        } else {
          if (videoTrackOn.length >= 12) {
            const toast = {
              type: 'Info',
              message: 'The discussion has the limit of cameras ON.',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
            return;
          }
          this.startLocalCameraStream();
        }
        await this.toggleOwnVideo();
      },
      startLocalCameraStream() {
        const videoDevice = localStorage.getItem('preferredVideoDevice');
        let constraints = (window.constraints = {
          audio: false,
          video: true,
        });

        if (videoDevice) {
          constraints = window.constraints = {
            audio: false,
            video: {
              deviceId: videoDevice ? { exact: videoDevice } : undefined,
            },
          };
        }
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then((stream) => {
            document.querySelector('.local-camera').srcObject = stream;
          })
          .catch((error) => {
            alert("Browser doesn't support or there is some errors." + error);
          });
      },
      stopLocalCameraStream() {
        let video = document.querySelector('.local-camera');
        let tracks = video.srcObject.getTracks();
        tracks.forEach((track) => {
          track.stop();
        });
        video.srcObject = null;
      },
      async toggleOwnAudio() {
        await toggleOwnAudio(this.$route.params.liveDiscussionID);
        this.muted = !this.muted;
      },
      async toggleOwnVideo() {
        await toggleOwnVideo(this.$route.params.liveDiscussionID);
        this.camera = !this.camera;
      },
      muteAudio() {
        this.muted = true;
        this.$emit('muteAudio');
      },
      unmuteAudio() {
        this.muted = false;
        this.$emit('unmuteAudio');
      },
      videoOff() {
        this.$emit('videoOff');
      },
      videoOn() {
        this.$emit('videoOn');
      },
      timeClockOfLiveDiscussion() {
        const time_now = new Date();
        const start_LD_time = new Date(
          this.getCurrentDiscussion.discussion_start_time
        );
        const db_discussion_time = Number(
          this.getCurrentDiscussion.discussion_time
        );

        const discussion_time =
          db_discussion_time + moment(time_now - start_LD_time).valueOf();

        this.discussion_time = moment
          .utc(Number(discussion_time))
          .format('HH:mm:ss');
      },
      onQueue(userID) {
        return this.getQueue.find((queue) => queue.user_id === userID);
      },
      isTeacherOnline(teacher_id) {
        return this.getCurrentDiscussion.users_present.includes(teacher_id);
      },
      isCoTeacherOnline(coteacher_id) {
        return (
          this.getCurrentDiscussion.users_present.includes(coteacher_id) &&
          coteacher_id !== this.getCurrentDiscussion.author_id
        );
      },
      createTeacherLocalVideoTrack() {
        const user_id = this.getProfile.id;
        const localPlayerContainer = document.createElement('div');
        localPlayerContainer.id = user_id;
        localPlayerContainer.style.top = '0';
        localPlayerContainer.style.height = '100%';
        localPlayerContainer.style.width = '100%';
        localPlayerContainer.style.position = 'absolute';
        localPlayerContainer.style.borderRadius = '0 0 4px 4px';
        const discussion_circle = document.getElementById(
          `circle-list-${user_id}`
        );

        discussion_circle.appendChild(localPlayerContainer);
        this.rtc.localVideoTrack.play(localPlayerContainer);

        const trackID = this.rtc.localVideoTrack.getTrackId();
        const elementVideo = document.querySelector(
          `[id^="agora-video-player-${trackID}"]`
        );
        elementVideo.style.borderRadius = '0 0 4px 4px';
        if (elementVideo) elementVideo.style.opacity = 100;
      },

      createStudentLocalVideoTrack() {
        const user = this.getCurrentDiscussion.turns_in_circle.find(
          (t) =>
            t.participation.user.id === this.getProfile.id &&
            t.turn_type !== 'video_audio_on'
        );
        if (user) {
          const user_id = user.participation.user.id;

          const localPlayerContainer = document.createElement('div');
          localPlayerContainer.id = user_id;
          localPlayerContainer.style.top = '0';
          localPlayerContainer.style.height = '100%';
          localPlayerContainer.style.width = '100%';
          localPlayerContainer.style.position = 'absolute';
          localPlayerContainer.style.borderRadius = '0 0 4px 4px';

          const discussion_circle = document.getElementById(
            `circle-list-${user_id}`
          );

          discussion_circle.appendChild(localPlayerContainer);
          this.rtc.localVideoTrack.play(localPlayerContainer);

          const trackID = this.rtc.localVideoTrack.getTrackId();
          const elementVideo = document.querySelector(
            `[id^="agora-video-player-${trackID}"]`
          );
          elementVideo.style.borderRadius = '0 0 4px 4px';
          if (this.my_participation.video_is_enabled) {
            if (elementVideo) elementVideo.style.opacity = 100;
          } else {
            if (elementVideo) elementVideo.style.opacity = 0;
          }
        }
      },
      openDeviceSettings() {
        if (this.my_participation.audio_is_enabled === true) {
          this.toggleOwnAudio();
        }
        EventBus.$emit('end-live-audio');
        this.camera = false;
        this.muted = true;
        if (
          this.getCurrentDiscussion.is_live &&
          this.getCurrentDiscussion.audio_discussion_is_enabled
        ) {
          const user = this.getCurrentDiscussion.turns_in_circle.find(
            (t) => t.participation.user.id === this.getProfile.id
          );
          if (user) {
            turnOffStudentParticipation(
              this.getCurrentDiscussion.id,
              user.participation.id
            );
          }
        }
      },
      closeNewFeedbackModal() {
        this.show_saved_feedback_modal = false;
        this.set_edit_saved_feedback = false;
        this.feedback_id = '';
        this.feedback_content = '';
        EventBus.$emit('showTemplateModal');
      },
      closeImportFeedbackTemplatesModal() {
        this.show_import_feedback_modal = false;
        EventBus.$emit('showTemplateModal');
      },
      cancelDeleteSavedFeedback() {
        this.show_confirm_delete_feedback = false;
        EventBus.$emit('showTemplateModal');
      },
      confirmDeleteSavedFeedback() {
        this.$store
          .dispatch('deleteFeedback', {
            course_id: this.getCourseDetail.id,
            feedback_id: this.feedback_to_delete.id,
            onlineRT: false,
          })
          .then(() => {
            this.feedback_to_delete = {};
            this.show_confirm_delete_feedback = false;
            EventBus.$emit('showTemplateModal');
          });
      },
      openStudentAssessment(turn) {
        if (this.second_screen) return;
        if (this.hasTeacherPermissionsInCourse) {
          const participation = {
            id: turn.participation.id,
            user_id: turn.participation.user.id,
          };
          EventBus.$emit('openAssessmentStudent', participation);
        }
      },
      slide(direction) {
        const slidesContainer = document.getElementById('slides-container');
        if (direction === 'right') {
          slidesContainer.scrollLeft += 300;
        } else {
          slidesContainer.scrollLeft -= 300;
        }
      },
      showArrows() {
        this.$nextTick(() => {
          const slide_cards = document.getElementById('slide-cards');
          const slides_container = document.getElementById('slides-container');
          if (slide_cards && slides_container) {
            const slide = this.hasTeacherPermissionsInCourse
              ? slide_cards.getBoundingClientRect().width
              : slide_cards.getBoundingClientRect().width + 130;
            if (slide > slides_container.getBoundingClientRect().width) {
              return (this.show_arrows = true);
            }
          }
          return (this.show_arrows = false);
        });
      },
    },
    created() {
      if (this.discussion_is_live) {
        setInterval(() => {
          this.timeClockOfLiveDiscussion();
        }, 1000);
      }
    },
    mounted: async function () {
      window.addEventListener('mousemove', this.handleMouseMove);
      this.startMouseMoveTimer();
      if (this.rtc.localAudioTrack) {
        this.muted = !this.rtc.localAudioTrack._enabled;
      }
      if (this.rtc.localVideoTrack) {
        this.camera = this.rtc.localVideoTrack._enabled;
      }
      if (
        this.getCurrentDiscussion.is_live &&
        this.getCurrentDiscussion.audio_discussion_is_enabled
      ) {
        const user = this.getCurrentDiscussion.turns_in_circle.find(
          (t) => t.participation.user.id === this.getProfile.id
        );
        if (user) {
          turnOffStudentParticipation(
            this.getCurrentDiscussion.id,
            user.participation.id
          );
        }
      }

      if (this.second_screen) this.second_screen_modal = true;

      window.addEventListener('resize', () => {
        this.showArrows();
      });

      this._addIdleListeners();
      this._setActive();

      EventBus.$on('resize-section', (state) => {
        this.isNotepadOpen = state;
        this.showArrows();
      });
      EventBus.$on('toggle-student-participation-audio', (participation) => {
        const participationToUpdate =
          this.getCurrentDiscussion.participations.find(
            (p) => p.id === participation.id && p.user_id === this.getProfile.id
          );
        if (participationToUpdate) {
          if (participation.audio_is_enabled) {
            this.unmuteAudio();
          } else {
            this.muteAudio();
          }
        }
      });
      EventBus.$on('reset-view', () => {
        this.selectedLiveView = 'one_columns';
      });
      EventBus.$on('toggle-student-participation-video', (participation) => {
        const participationToUpdate =
          this.getCurrentDiscussion.participations.find(
            (p) => p.id === participation.id && p.user_id === this.getProfile.id
          );
        if (participationToUpdate) {
          if (participation.video_is_enabled) {
            this.videoOn();
          } else {
            this.videoOff();
          }
        }
      });
      EventBus.$on('mute-participation', () => {
        if (this.my_participation) {
          this.muteAudio();
        }
      });
      EventBus.$on('video-off-mute-participation', () => {
        if (this.my_participation) {
          this.muteAudio();
          this.videoOff();
        }
      });

      setInterval(async () => {
        await internetConnection();
      }, 10000);

      EventBus.$on('check-user-local-camera', async (participation_id) => {
        const participationToUpdate =
          this.getCurrentDiscussion.participations.find(
            (p) => p.id === participation_id && p.user_id === this.getProfile.id
          );
        const videoTrackOn = this.remoteUsers.filter((r) => r._videoTrack);
        if (
          participationToUpdate &&
          !participationToUpdate.video_is_enabled &&
          this.camera &&
          videoTrackOn.length < 12
        ) {
          await toggleOwnVideo(this.$route.params.liveDiscussionID);
        }
        setTimeout(() => {
          this.showArrows();
        }, 100);
      });
      EventBus.$on('discussion_expired', () => {
        this.show_stopped_modal = true;
        this.$store.dispatch('endAudioCall', this.getCurrentDiscussion.id);
      });
      EventBus.$on('restartLD', () => {
        setInterval(() => {
          this.timeClockOfLiveDiscussion();
        }, 1000);
      });
      EventBus.$on('student_nudged', (nudge_message) => {
        const student_nudge = {
          type: 'Nudge',
          message: nudge_message,
        };
        EventBus.$emit('createToast', student_nudge);
      });

      EventBus.$on('currently_speaker', () => {
        if (this.$route.name === 'live-discussion.discussion') {
          const toast = {
            type: 'Info',
            message: 'You are the Speaker',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
        }
      });

      EventBus.$on('bad-network-quality', async (value) => {
        this.show_bad_network_quality = value;
      });

      EventBus.$on('teacher_tap_in', (payload) => {
        this.$store.dispatch('teacherTapIn', payload);
      });

      EventBus.$on('teacher_tap_out', () => {
        this.$store.dispatch('teacherTapOut').then(() => {
          if (
            this.my_participation &&
            this.my_participation.user_id ===
              this.getCurrentDiscussion.currently_active
          ) {
            return toggleOwnAudio(this.$route.params.liveDiscussionID);
          }
        });
      });
      EventBus.$on('queueLoading', (value) => {
        this.loading_queue = value;
      });
      EventBus.$on('newSavedFeedback', () => {
        this.show_saved_feedback_modal = true;
      });
      EventBus.$on('showImportFeedback', () => {
        this.show_import_feedback_modal = true;
      });
      EventBus.$on('editSavedFeedback', (value) => {
        this.feedback_id = value.feedback_id;
        this.feedback_content = value.feedback_content;
        this.show_saved_feedback_modal = true;
        this.set_edit_saved_feedback = true;
      });
      EventBus.$on('deleteSavedFeedback', (value) => {
        this.feedback_to_delete = value;
        this.show_confirm_delete_feedback = true;
      });
    },

    beforeDestroy() {
      this._removeIdleListeners();
      if (this._idleTimer) clearTimeout(this._idleTimer);

      EventBus.$off('toggle-student-participation-audio');
      EventBus.$off('toggle-student-participation-video');
      EventBus.$off('video-off-mute-participation');
      EventBus.$off('mute-participation');
      EventBus.$off('check-user-local-camera');
      EventBus.$off('restartLD');
      EventBus.$off('discussion_expired');
      EventBus.$off('student_nudged');
      EventBus.$off('currently_speaker');
      EventBus.$off('bad-network-quality');
      EventBus.$off('teacher_tap_in');
      EventBus.$off('teacher_tap_out');
      EventBus.$off('queueLoading');
      EventBus.$off('editSavedFeedback');
      EventBus.$off('deleteSavedFeedback');
      EventBus.$off('showImportFeedback');
      EventBus.$off('newSavedFeedback');
      EventBus.$off('resize-section');
      window.removeEventListener('mousemove', this.handleMouseMove);
    },
  };
</script>
<style scoped>
  .verbal-background-image {
    background-image: url('~/static/live_discussion/blank_participations.svg');
  }
  .bar-fade-slide-enter-active, .bar-fade-slide-leave-active {
    transition: opacity .18s ease, transform .18s ease;
  }
  .bar-fade-slide-enter, .bar-fade-slide-leave-to {
    opacity: 0;
    transform: translateY(8px);
  }
</style>
<style lang="stylus" scoped>
  .columns-circle-container
    height: calc(100% - 60px)
  .discussion-circle-container
    height: calc(100vh - 283px)
  .discussion-circle-container-fullscreen
    height: calc(100vh - 139px)
  .discussion-circle-container-video
    height: calc(100vh - 406px)
  .discussion-circle-container-video-fullscreen
    height: calc(100vh - 262px)
  .gavel-style
    color: #8E785D
    i
      font-size: 24px
      line-height: 32px
      transform: matrix(-1, 0, 0, 1, 0, 0)
  .nudge-msg
    border-radius: 0.5em
    position: absolute
    margin: 0 auto;
    z-index: 50;
    bottom: 0px
    left: 50%;
    transform: translateX(-50%)
    align-self:center
    //transform: translate(-15%, 0%)
    animation-name: nudge
    animation-duration: 3.5s
    animation-iteration-count: infinite
    span
      font-weight: bold
  .nudge-message-container
    max-width: 300px
    max-height:100px
    overflow-y: auto
    word-wrap: break-word
    &&::-webkit-scrollbar
      display: unset !important
      width: unset !important
  .local-camera
    transform: scaleX(-1)
    border-radius: 5px
  .slides-container
    height: 100%
    width: 100%
    display: flex
    overflow: scroll
    scroll-behavior: smooth
    overflow-y: hidden
    &::-webkit-scrollbar {
      display: none
    }
</style>



// WEBPACK FOOTER //
// LDDiscussionTab.vue?061766d6